export type PlanTier = 'FREE' | 'PAID';

/** `GET /institution/{id}/plan`. `employeeCap` is null when the plan has no cap (PAID). */
export interface IInstitutionPlan {
    planTier: PlanTier;
    employeeCount: number;
    employeeCap: number | null;
    allowedModules: string[];
}

export type FreeTierLimitKind = 'EMPLOYEES' | 'DEVICE_SYNC' | 'MODULE';

/** Body of the 403 the server sends when a Free plan limit refuses a write. Key off `code`, never `message`. */
export interface IFreeTierLimitError {
    code: 'FREE_TIER_LIMIT';
    limit: FreeTierLimitKind;
    cap: number | null;
    current: number | null;
    message: string;
}

/** Mirrors the backend's FreeTierPolicy.MAX_EMPLOYEES; only used in explanations, never to enforce. */
export const FREE_EMPLOYEE_CAP = 10;

/**
 * Mirrors the backend's FreeTierPolicy.ALLOWED_MODULES. Used to preview a downgrade before the server
 * has answered; once an institution is FREE, its plan's `allowedModules` is what counts.
 */
export const FREE_ALLOWED_MODULES: readonly string[] = ['attendance', 'leave', 'people'];
